import http from '../../services/httpService';

export const getAudits = async (application_name, user_email, action_name, date_range_start, date_range_end, order_by, start_at, response_size) => 
  await http.get(`/v1/audit_log?application_name=${application_name}&user_email=${user_email}&action_name=${action_name}&start_date=${date_range_start}&end_date=${date_range_end}&order_by=${order_by}&start_at=${start_at}&response_size=${response_size}`);

export const getAuditOptions = async () => await http.get(`/v1/audit_log/options`);

